module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec01_img_02-1b14d1e37c39b7470411b92f2125672b.png";